import { Node } from '@tiptap/core';

/**
 * Spans that carry a styling hook survive the editor.
 *
 * Generated documents hang their inline styling off classes: a label beside a gold value, an
 * empty <span class="sline"> that IS the rule a client signs on. Nothing in the stock schema
 * matches a bare span, so ProseMirror unwrapped every one of them and the class went with it —
 * an empty span vanished outright and its stylesheet rule matched nothing.
 *
 * A span with no class or id is left to the marks, which is where the editor's own color,
 * font size and highlighting live.
 */
export const SpanNode = Node.create({
  name: 'span',

  group: 'inline',
  inline: true,
  content: 'inline*',

  parseHTML() {
    return [
      {
        tag: 'span',
        // Above the default 50 that TextStyle, FontSize and the other span marks parse at.
        priority: 51,
        getAttrs: (element) =>
          element.getAttribute('class') || element.getAttribute('id') ? null : false
      }
    ];
  },

  renderHTML({ HTMLAttributes }) {
    return ['span', HTMLAttributes, 0];
  }
});
